module.exports = __webpack_public_path__ + "img/Teva_Pharmaceutical.931fb5c3.svg";